module.exports = __webpack_public_path__ + "img/sm-instagram.961b46dd.png";